import './sass/style.scss'
import FloatMenu from './js/modules/FloatMenu'
import Newsletter from './js/modules/Newsletter'
import SiteHeader from './js/modules/SiteHeader/SiteHeader'
import SlideCordion from './js/modules/SlideCordion'
import SlideCordionExtend from './js/modules/SlideCordionExtend'
import Tooltip from './js/modules/Tooltip'
import { BookingFront } from '../components/Booking/frontend/js/BookingFront'
import { ClosePopup } from './js/modules/ClosePopup'
import { MobileMenu } from './js/modules/MobileMenu'
import { PartnerSlider } from './js/modules/PartnerSlider'
import { Popup } from './js/modules/Popup'
import { SliderHotpoint } from './js/modules/SliderHotpoint'
import { TestimonialSlider } from './js/modules/TestimonialSlider'
import { TopScroll } from './js/modules/TopScroll'
import { WindowWidth } from './js/utils/WindowWidth'
import { setEmptySpaceOnMobile } from './js/utils/emptySpacer'
import { smoothScroll } from './js/modules/scroll'
import { toFullWidthInWrapper } from './js/utils/utils'
import GoogleMap from './js/modules/GoogleMap'
import Filters from '../components/filters/ts/Filters'
import ToggleFormFields from '../components/form/ts/ToggleFormFields'
import '../components/accordion'
import checkAllInputs from './js/modules/CheckAllInputs'
import Accordions from './js/modules/Accordions'


new WindowWidth()
new Tooltip().setDefault()

window.addEventListener('load', () => {
  new SiteHeader()
  new MobileMenu()
  new TestimonialSlider()
  new PartnerSlider()
  new SliderHotpoint()
  new ClosePopup()
  new checkAllInputs()
  new Accordions()
  document.querySelectorAll('.js-intro-top-scroll').forEach(item => new TopScroll(item as HTMLElement))
  document.querySelectorAll('.js-accordion-slider').forEach(item => new SlideCordion(item as HTMLElement))
  document.querySelectorAll('.js-accordion-slider-extend').forEach(item => new SlideCordionExtend(item as HTMLElement))
  smoothScroll()
  toFullWidthInWrapper()
  Popup()
  document.querySelectorAll('.newsletter form').forEach(form => new Newsletter(form as HTMLFormElement))
  setEmptySpaceOnMobile()
  document.querySelectorAll('.js-float-menu').forEach(item => new FloatMenu(item as HTMLElement))

  window.addEventListener('resize', () => {
    new MobileMenu()
  })
})

window.addEventListener('DOMContentLoaded', () => {
  new BookingFront()

  const filtersForm = document.querySelector('.filters-form')
  if (filtersForm) new Filters(filtersForm as HTMLFormElement)

  document.querySelectorAll('.map-container').forEach(item => new GoogleMap(item as HTMLElement).createMap())

  const registerForms = document.querySelectorAll('.woocommerce-form-register')
  if (registerForms.length) {
    import('./js/modules/FloatLabels').then(() => {
      registerForms.forEach(
        container =>
          new ToggleFormFields(container as HTMLElement, {
            customer_company: ['nip', 'company_name', 'city', 'postcode'],
            customer_partner: ['nip', 'company_name', 'city', 'postcode'],
          }),
      )
    })
  }
})
